module.exports = __webpack_public_path__ + "img/3.970f7757.jpg";